module.exports = __webpack_public_path__ + "4056c1eea272e9ba2079c399dbf2780d.svg";